import React from 'react'
import {Icon, ParagraphText} from '@thryvlabs/maverick'
import {useLocation} from 'react-router-dom'
import {
  // getFormattedDate, getFormattedTime,
  getFormattedDateTime,
} from '../utils/util'
import {BlueGradientBackground} from '../components/AuthForm'
import CheckIcon from '../assets/check.svg'
import '../styles/formScreensStyles.css'
import {useSelector} from 'react-redux'

export const AcknowledgementComponent = () => {
  let data = useLocation()
  const {isMobileViewEnable} = useSelector(state => state.screenView)

  const Appointment = ({appointment, title}) => (
    <div className="appointment-card d-flex flex-row w-100">
      <ParagraphText
        variant="reg"
        className="m-0 appointment-title"
        color="#231F20"
      >
        {title}
      </ParagraphText>
      <ParagraphText variant="reg" className="m-0 appointment-time">
        {': '}
        <span className="appointment-datetime">
          {getFormattedDateTime(appointment)}
        </span>
      </ParagraphText>
    </div>
  )

  return (
    <>
      <BlueGradientBackground showLogo={true} backgroundHexColor="#F4F6FB" />

      <section className="acknowledgement-container">
        <div
          className={`acknowledgement-card ${isMobileViewEnable ? 'w-80' : ''}`}
        >
          <div className="acknowledgement-content d-flex flex-column align-items-center">
            <img src={CheckIcon} alt="Logo" className="check-icon" />
            <p className="acknowledgement-title">Thank you</p>

            <p
              style={{
                fontFamily: 'Open Sans',
                fontWeight: '400',
                fontSize: '16px',
                leadingTrim: 'NONE',
                lineHeight: '22px',
                letterSpacing: '0px',
                textAlign: 'center',
                verticalAlign: 'middle',
                marginBottom: '16px',
              }}
            >
              Your payment information has been successfully updated. We will
              use this information to bill your Thryv subscriptions each month.
              You can update your billing information through the My Account
              page.
            </p>
            <p
              style={{
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fontSize: '16px',
                leadingTrim: 'NONE',
                lineHeight: '22px',
                letterSpacing: '0px',
                textAlign: 'center',
                verticalAlign: 'middle',
                color: '#4D4D4D',
                marginBottom: '0px',
              }}
            >
              Your Thryv Purchase is now complete!
            </p>
            {data.state?.scheduleDetails?.apptDetails?.length > 0 && (
              <>
                {' '}
                <div
                  className="d-flex align-items-center"
                  style={{
                    columnGap: '12px',
                    marginTop: '10px',
                    marginBottom: '10px',
                  }}
                >
                  <Icon
                    type="regular"
                    variant="calendarClock"
                    height="20px"
                    width="22px"
                    color="#FF5000"
                  />
                  <ParagraphText
                    variant="reg"
                    style={{
                      fontWeight: 600,
                      fontSize: '16px',
                      marginBottom: '10px',
                    }}
                    className="m-0"
                  >
                    Your Upcoming Appointments
                  </ParagraphText>
                </div>
                {data.state?.scheduleDetails?.apptDetails?.map(item => {
                  // Determine title based on type and influencer status
                  let appointmentTitle = 'Website Design Call'
                  if (item.type === 'onboarding') {
                    appointmentTitle = data.state?.influencer_name
                      ? 'Marketing Center Kickoff Call'
                      : 'SEO/ Leads / Social Ads Kickoff Call'
                  }
                  return (
                    <Appointment
                      title={appointmentTitle}
                      key={item.type}
                      appointment={item}
                    />
                  )
                })}
              </>
            )}
          </div>
        </div>
      </section>
    </>
  )
}
